module.exports = __webpack_public_path__ + "img/burshtat_mob_portfolio_4.624d3252.png";